<template>
    <div>
        <div class="row">
            <div class="col-12">
                <h2 class="title">Děkujeme</h2>

                Registrace proběhla úspěšně. Nyní pokračujte do servisní sekce,
                kde můžete dokončit prezentaci vaší firmy.

                <div class="row mt-5">
                    <div class="col-6 col-sm-10">
                        <a :href="linkToSS" class="button-02">
                            Pokračovat
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormWizardFirmNopay',
    data() {
        return {
            paid: false,
        }
    },
    computed: {
        linkToSS() {
            return `http://scripts.ci.cz/toSS.php?web=ceskestavby&fid=${this.$store.state.firm.result.id_firmy}&ftoken=${this.$store.state.firm.result.opravny_kod}`
        },
    },
}
</script>
